import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useUIControls = () => {
  const { appConfig, featureFlags } = useConfigStore.getState();

  const logoURL = appConfig?.branding?.logo_url;
  const buttonLabelOnly = appConfig?.ui_controls?.button_display_modes?.label_only;
  const buttonIconOnly = appConfig?.ui_controls?.button_display_modes?.icon_only;
  const buttonLabelWithIcon = appConfig?.ui_controls?.button_display_modes?.label_with_icon;

  const epgNoProgramText = featureFlags?.feature_flags?.epg_settings?.epg_no_program_message;
  const epgEmptySlotText = featureFlags?.feature_flags?.epg_settings?.epg_empty_slot_message;
  const epgDisplayHours = featureFlags?.feature_flags?.epg_settings?.epg_display_hours;
  const epgTimeFormat = featureFlags?.feature_flags?.epg_settings?.epg_time_format;
  const epgDefaultImage = featureFlags?.feature_flags?.epg_settings?.epg_default_image;
  const epgDisabledMessage = featureFlags?.feature_flags?.epg_disabled_message;
  const heroBanner = featureFlags?.ui_settings?.hero_banner;

  return {
    buttonLabelOnly,
    buttonIconOnly,
    buttonLabelWithIcon,
    logoURL,
    epgNoProgramText,
    epgEmptySlotText,
    epgDisplayHours,
    epgTimeFormat,
    epgDefaultImage,
    epgDisabledMessage,
    heroBanner,
  };
};
